export const API = "https://appointy-x5ue.onrender.com";
